import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

Vue.use(Router)

const ifNotAuthenticated = (to, from, next) => {
    if (!store.state.auth.user.token) {
        next()
        return
    }
    next('/home')
}

const ifAdmin = (to, from, next) => {
    const auth = store.state.auth.user.auth
    if (auth && (auth === 'admin' || auth === 'superuser')) {
        next()
        return
    }
    next({
        path: '/'
    })
}

const ifSuspended = (to, from, next) => {
    const user = store.state.auth.user
    if (user && (user.status === 'suspended')) {
        next()
        return
    }
    next({
        path: '/',
    })
}

const ifAuthenticated = (to, from, next) => {
    if (store.state.auth.user.token) {
        if (store.state.auth.user.status === 'active') {
            next()
            return
        } else {
            next({
                path: '/suspended'
            })
            return
        }
    }
    next({
        path: '/',
        query: {redirect: to.path, ...to.query}
    })
}

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            component: () => import('./layouts/BaseLayout.vue'),
            props: {home: true},
            beforeEnter: ifNotAuthenticated,
            children: [
                {
                    name: 'logInOrSignOn',
                    path: '',
                    components: {
                        default: () => import('./pages/LogInOrSignOn.vue'),
                        nav: () => import('./pages/LogIn.vue')
                    }
                },
            ],
        },
        {
            path: '/home',
            component: () => import('./layouts/BaseLayout.vue'),
            props: {home: false},
            children: [
                {
                    name: 'home',
                    path: '',
                    components: {
                        default: () => import('./pages/Home.vue'),
                        nav: () => import('./components/NavBar.vue')
                    }
                },
            ],
            beforeEnter: ifAuthenticated
        },
        {
            path: '/edit_profile',
            component: () => import('./layouts/BaseLayout.vue'),
            children: [
                {
                    name: 'editProfile',
                    path: '',
                    components: {
                        default: () => import('./pages/EditProfile.vue'),
                        nav: () => import('./components/NavBar.vue')
                    }
                },
            ],
            beforeEnter: ifAuthenticated
        },
        {
            path: '/create',
            component: () => import('./layouts/BaseLayout.vue'),
            children: [
                {
                    name: 'create',
                    path: '',
                    components: {
                        default: () => import('./pages/Create.vue'),
                        nav: () => import('./components/NavBar.vue')
                    }
                },
            ],
            beforeEnter: ifAuthenticated
        },
        {
            path: '/bracket',
            component: () => import('./layouts/BaseLayout.vue'),
            children: [
                {
                    name: 'bracket',
                    path: '',
                    components: {
                        default: () => import('./components/Bracket.vue'),
                    }
                },
            ],
        },
        {
            path: '/manage',
            component: () => import('./layouts/BaseLayout.vue'),
            children: [
                {
                    name: 'manage',
                    path: '',
                    components: {
                        default: () => import('./pages/Manage.vue'),
                        nav: () => import('./components/NavBar.vue')
                    }
                },
            ],
            beforeEnter: ifAuthenticated
        },
        {
            path: '/admin',
            component: () => import('./layouts/BaseLayout.vue'),
            props: {fluid: true},
            children: [
                {
                    name: 'admin',
                    path: '',
                    components: {
                        default: () => import('./pages/Admin.vue'),
                        nav: () => import('./components/AdminNavBar.vue')
                    },
                    redirect: '/admin/users'
                },
                {
                    name: 'adminUsers',
                    path: 'users',
                    components: {
                        default: () => import('./pages/Users.vue'),
                        nav: () => import('./components/AdminNavBar.vue')
                    }
                },
                {
                    name: 'adminInstaplays',
                    path: 'instaplays',
                    components: {
                        default: () => import('./pages/InstaplaysAdmin.vue'),
                        nav: () => import('./components/AdminNavBar.vue')
                    }
                },
                {
                    name: 'adminInstaplaysList',
                    path: 'instaplays/:type/:date/:user',
                    components: {
                        default: () => import('./pages/InstaplaysListAdmin.vue'),
                        nav: () => import('./components/AdminNavBar.vue')
                    }
                },
                {
                    name: 'adminInstaplaysListUser',
                    path: 'user/:user',
                    components: {
                        default: () => import('./pages/AdminUserInfo.vue'),
                        nav: () => import('./components/AdminNavBar.vue')
                    }
                }
            ],
            beforeEnter: ifAdmin
        },
        {
            path: '/suspended',
            component: () => import('./pages/Suspended.vue'),
            beforeEnter: ifSuspended
        },
        {
            path: '*',
            component: () => import('./pages/Error404.vue')
        },
        {
            path: '/reset_password',
            component: () => import('./layouts/FormLayout.vue'),
            children: [
                {
                    name: 'resetPassword',
                    path: '',
                    component:() => import('./pages/ResetPassword.vue'),
                    props: {column: true, dark: false},
                },
            ],
        },
    ]
})
